import i18next from 'i18next';

export const validate = values => {
  const errors = {};

  // Name
  if (!values.name) {
    errors.name = i18next.t('questionnaire_name_validate');
  }

  // Type
  if (values.type.id === 0) {
    errors.type = { name: i18next.t('questionnaire_type_validate') };
  }

  // Licensor
  if (!values.licensor) {
    errors.licensor = i18next.t('licensor_validate');
  } else if (values.licensor.length > 50) {
    errors.licensor = i18next.t('licensor_length_validate');
  }

  // Date
  if (!values.publication_date || !values.removal_date) {
    errors.publication_date = true;
  }

  // Users & Accommodations
  if (
    values.questionnaire_accommodations.length === 0 &&
    !values.accommodation_all &&
    values.user_id.length === 0 &&
    values.questionnaire_organizations.length === 0 &&
    !values.organization_all
  ) {
    errors.user_id = i18next.t('user_notification_validate');
    errors.questionnaire_accommodations = i18next.t('accommodations_validate');
    errors.questionnaire_organizations = i18next.t('validate_organizations');
  } else if (values.user_id.length === 0) {
    if (
      (values.questionnaire_accommodations.length !== 0 ||
        values.accommodation_all) &&
      values.questionnaire_organizations.length === 0 &&
      !values.organization_all
    ) {
      errors.questionnaire_organizations = i18next.t('validate_organizations');
    } else if (
      (values.questionnaire_organizations.length !== 0 ||
        values.organization_all) &&
      values.questionnaire_accommodations.length === 0 &&
      !values.accommodation_all
    ) {
      errors.questionnaire_accommodations = i18next.t(
        'accommodations_validate'
      );
    }
  }

  // Organizations
  // if (
  //   values.questionnaire_organizations.length === 0 &&
  //   !values.organization_all
  // ) {
  //   errors.questionnaire_organizations = i18next.t('validate_organizations');
  // }

  return errors;
};
